import Vue from "vue"
import Router from "vue-router"
import Redirect from "../Redirect"
import GoogleAssistantLinkAccount from "../GoogleAssistantLinkAccount"
import Home from "../Home.vue"
import PublicTournaments from "@/components/PublicTournaments"
import MyTournaments from "@/components/MyTournaments"
import MyLocations from "@/components/MyLocations"
import Tournament from "@/components/Tournament"
import Location from "@/components/Location"
import About from "@/components/About"
import Help from "@/components/Help"
import ContactInfo from "@/components/ContactInfo"

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/googleassistantlinkaccount",
      name: "GoogleAssistantLinkAccount",
      component: GoogleAssistantLinkAccount
    },
    { path: "/redirect", name: "Redirect", component: Redirect },
    {
      path: "/",
      name: "Home",
      component: Home,
      props: true,
      children: [
        { path: "publicTournaments", components: { body: PublicTournaments } },
        { path: "myTournaments", components: { body: MyTournaments } },
        { path: "myLocations", components: { body: MyLocations } },
        { path: "tournament", components: { body: Tournament } },
        { path: "location", components: { body: Location } },
        { path: "about", components: { body: About } },
        { path: "contact", components: { body: ContactInfo } },
        { path: "help", components: { body: Help } }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js